import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=8c59ee40&scoped=true&"
import script from "./EventCard.vue?vue&type=script&lang=js&"
export * from "./EventCard.vue?vue&type=script&lang=js&"
import style1 from "./EventCard.vue?vue&type=style&index=1&id=8c59ee40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c59ee40",
  null
  
)

export default component.exports